import { createContext } from "react";
import type { AreaChartActions } from "../AreaChartProvider.types";

const AreaChartActionsContext = createContext<AreaChartActions<unknown> | undefined>(undefined);
AreaChartActionsContext.displayName = "AreaChartActionsContext";

export default AreaChartActionsContext;
